import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { Button } from '@components/common';

import { auth } from '@store/selectors';
import { useAppSelector } from '@store/store';

import { EUserRoles } from '@enums/common';

import { EErrorPageCodeKey, errorText } from './constants';

import styles from './ErrorPage.module.scss';

interface IErrorPageProps {
	hideBar?: () => void;
	errorKey?: keyof typeof EErrorPageCodeKey;
}

const ErrorPage = ({
	hideBar,
	errorKey = EErrorPageCodeKey.noAccess,
}: IErrorPageProps) => {
	const { user } = useAppSelector(auth);

	const isDefaultRoleOnly = user?.roles?.every((role) => role === EUserRoles.defaultRole);

	const navigate = useNavigate();

	useEffect(() => {
		if (hideBar) hideBar();
	}, [hideBar]);

	const isNotFound = errorKey === EErrorPageCodeKey.notFound;

	const buttonHandler = () => !isNotFound ? navigate(-1) : navigate(`/`);

	const { title, text, btnText } = errorText[isDefaultRoleOnly ? EErrorPageCodeKey.noRoles : errorKey];

	return (
		<div className={styles.pageWrapper}>
			<div className={styles.pageContent}>
				<div className={styles.header}>{title}</div>
				<div className={styles.text}>{text}</div>
				{btnText &&
					<Button
						large
						onClick={buttonHandler}
						text={btnText}
					/>
				}
			</div>
		</div>
	);
};

export default ErrorPage;
